import { useState } from "react";
import {BASE_URL} from "../../url";
import { database } from '../../config';
import { signInWithEmailAndPassword } from 'firebase/auth';
import {Link, useNavigate} from "react-router-dom";

function LoginPage() {
  const history  = useNavigate();
  const [username, setUserName] = useState('');
  const [password, setpassword] = useState('');

  function login(ev) {
    ev.preventDefault();
    signInWithEmailAndPassword(database, username, password).then((data)=>{
        console.log(data, "authData");
        history('/getProductOnBrandAndCategory')
    }).catch(err=>{
        alert(err.code)
    })
    console.log("user details", username, password)
  }

  return (
    <>
    <form className="login-page" onSubmit={login}>
      <div className="form">
        <h2 style={{color: "#5f5f5f"}}>LOGIN</h2>
        <input type="text" placeholder="USERNAME (Try test@gmail.com)" className="username" value={username} onChange={ev => setUserName(ev.target.value)} required/>
        <input type="password" placeholder="PASSWORD (Try test123)" className="password" value={password} onChange={ev => setpassword(ev.target.value)} required/>
        <button type="submit">LOGIN</button>
      </div>
    </form>
    <div class="center">"This is my hobby Project! Feel free to login with credentials provided in the placeholder."</div>
    </>
  )
}

export default LoginPage